const colors = {
  primary: {
    50: '#7D5C97',
    100: '#714D8E',
    200: '#653E84',
    300: '#5A307B',
    400: '#4E2171',
    500: '#421268',
    600: '#3A105B',
    700: '#320E4E',
    800: '#290B41',
    900: '#210934',
  },
}

export default colors
